export { default } from './P10NewsTeaser';
